const cardStyle = {
  borderRadius: "25px",
  padding: "20px",
  paddingTop: "50px",
  backgroundColor: "#efefe9 !important",
};

export default cardStyle;
